import React, {FC, ReactElement, useEffect} from "react";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import {templateApi} from "../../backend/TemplateApi";
import {uiStateStore} from "../../store/UiState";

interface IProps {
    templateId: string
}

export const OpenDocsTemplate: FC<IProps> = ({templateId}): ReactElement => {
    const language = uiStateStore.language;

    useEffect(() => {
        templateApi.getClientDocTemplatePreviewLink(language, templateId)
                .then(({link}) => window.location.href = link)
    }, [templateId, language])
    return <>
        <LoaderWithCompanySelected loading={true}>
        </LoaderWithCompanySelected>
    </>
};